// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._19pk1b66{margin-top:var(--ds-space-050,4px)}", ""]);
// Exports
module.exports = exports;
